import { render, staticRenderFns } from "./CurrencySymbol.vue?vue&type=template&id=a67b79a2&scoped=true&"
import script from "./CurrencySymbol.vue?vue&type=script&lang=js&"
export * from "./CurrencySymbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b79a2",
  null
  
)

export default component.exports